export default __webpack_public_path__ + "static/media/FicWorld.e913aa10.png";